import { postRequest, putRequest } from "../../config/AxiosConfig";
import API_URLS from "../../config/BackendConfig";
import { getAuthToken } from "../../utils/tokenUtils"

export const MobileDeviceLockReportService = async (params = {}) => {
  try {
    const token = getAuthToken();
    
    const queryParams = new URLSearchParams();
    if (params.status) queryParams.append("status", params.status);
    if (params.running) queryParams.append("running", params.running);
    if (params.search) queryParams.append("search", params.search);
    if (params.user_id) queryParams.append("user_id", params.user_id);
    if (params.per_page) queryParams.append("per_page", params.per_page);
    if (params.page) queryParams.append("page", params.page);

    const url = `${API_URLS.ADMIN}mobile-device/super-keys?${queryParams.toString()}`;

    const response = await postRequest({
      url: url,
      headers: { 
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      data: params
    });
    
    return response;
  } catch (error) {
    console.error("Error in MobileDeviceLockReportService:", error);
    throw error;
  }
};


// Action Lists
export const ActionListService = ({ payload }) => {
    try {
        const token = getAuthToken();
        const response = postRequest({
            url: API_URLS.ADMIN + "mobile-device/key-control/action-list",
            data: payload,
            headers: { 'Authorization': `Bearer ${token}` }
        })
        return response;
    } catch (error) {
     console.error("Error:", error);
    }
}


// Apply Action List
export const ApplyActionService = ({ payload}) => {
  try{
    const token = getAuthToken();
    const response = putRequest({
      url: API_URLS.ADMIN + "mobile-device/key-control/apply-action",
      data: payload,
      headers: { 'Authorization': `Bearer ${token}`}
    })
return response;
  } catch (error) 
  {
     console.error("Error:", error);
  }
}

// Get Action 
export const GetActionService = ({ payload }) => {
  try{
    const token = getAuthToken();
    const response = putRequest({
      url: API_URLS.ADMIN + "mobile-device/key-control/get-action",
      data: payload,
      headers: { 'Authorization': `Bearer ${token}`}
    })
    return response;
  } catch (error)
  {
    console.error("Error",error)
  }
}

// Action Status
export const StatusActionService = ({ payload }) => {
  try{
    const token = getAuthToken();
    const response = putRequest({
      url: API_URLS.ADMIN + "mobile-device/key-control/current-state-control",
      data: payload,
      headers: { 'Authorization': `Bearer ${token}`}
    })
    return response;
  } catch (error)
  {
    console.error("Error",error)
  }
}

